import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.resize();
    this.element.addEventListener("input", this.resize);
    this.element.addEventListener("keypress", this.submitWithShortcut);

    if (this.element.autofocus) {
      this.element.focus();
    }
  }

  disconnect() {
    this.element.removeEventListener("input", this.resize);
    this.element.removeEventListener("keypress", this.submitWithShortcut);
  }

  resize = () => {
    if (this.element.clientHeight < this.element.scrollHeight) {
      this.element.style.height = `${this.element.scrollHeight}px`;
    }
  };

  submitWithShortcut = (event) => {
    if ((event.ctrlKey || event.metaKey) && event.key === "Enter") {
      this.submitForm(event);
    }
  };

  submitForm(event) {
    if (!this.element.value) return;

    const submitButton = this.element.form.querySelector('[type="submit"]');

    if (submitButton) {
      submitButton.setAttribute("disabled", true);
    }

    this.element.form.requestSubmit();
    event.preventDefault();
  }
}
